import { Link } from 'react-router-dom';
import { Twitter, Instagram, Youtube, Facebook } from 'lucide-react';

const teams = [
  { name: 'Commanders', path: '/commanders' },
  { name: 'Nationals', path: '/nationals' },
  { name: 'Capitals', path: '/capitals' },
  { name: 'Wizards', path: '/wizards' },
  { name: 'Mystics', path: '/mystics' },
  { name: 'DC United', path: '/dcunited' },
  { name: 'DC Soccer', path: '/dcsoccer' },
  { name: 'Defenders', path: '/defenders' },
];

const company = [
  { name: 'About', path: '/about' },
  { name: 'Contact', path: '/contact' },
  { name: 'Podcast', path: '/podcast' },
];

const legal = [
  { name: 'Privacy', path: '/privacy' },
  { name: 'Editorial Standards', path: '/editorial-standards' },
  { name: 'Corrections', path: '/corrections' },
];

const socials = [
  { name: 'Twitter', icon: Twitter, url: 'https://x.com/dcsports_report' },
  { name: 'Instagram', icon: Instagram, url: 'https://instagram.com/dc_sports_report' },
  { name: 'YouTube', icon: Youtube, url: '#' },
  { name: 'Facebook', icon: Facebook, url: 'https://www.facebook.com/profile.php?id=61572918715634' },
];

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#002868] border-t-2 border-[#BF0A30]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_dcsportshub/artifacts/fw8w9adx_DCSportsReport_Logo.png"
                alt="DC Sports Report"
                className="h-14 w-auto"
              />
            </Link>
            <p className="font-heading text-white text-xl uppercase tracking-wide mt-4">
              DC Sports Report
            </p>
            <p className="text-slate-300 text-sm leading-relaxed mt-2 max-w-sm">
              Independent coverage, analysis and conversation surrounding Washington, D.C. sports.
            </p>
            <div className="flex gap-2 mt-5">
              {socials.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  data-testid={`social-link-${social.name.toLowerCase()}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 border border-white/25 flex items-center justify-center text-slate-300 hover:text-white hover:border-white transition-colors"
                  aria-label={social.name}
                >
                  <social.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Teams */}
          <div className="md:col-span-3">
            <h4 className="font-heading text-white text-sm uppercase tracking-[0.2em] mb-4">Teams</h4>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
              {teams.map((team) => (
                <li key={team.path}>
                  <Link
                    to={team.path}
                    data-testid={`footer-link-${team.name.toLowerCase().replace(' ', '-')}`}
                    className="text-slate-300 hover:text-white transition-colors text-sm"
                  >
                    {team.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-2">
            <h4 className="font-heading text-white text-sm uppercase tracking-[0.2em] mb-4">Company</h4>
            <ul className="space-y-2">
              {company.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    data-testid={`footer-link-${item.name.toLowerCase()}`}
                    className="text-slate-300 hover:text-white transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div className="md:col-span-2">
            <h4 className="font-heading text-white text-sm uppercase tracking-[0.2em] mb-4">Site</h4>
            <ul className="space-y-2">
              {legal.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    data-testid={`footer-link-${item.name.toLowerCase().replace(' ', '-')}`}
                    className="text-slate-300 hover:text-white transition-colors text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-6 border-t border-white/15">
          <p className="text-slate-400 text-xs leading-relaxed max-w-4xl">
            <strong className="text-slate-300">Disclaimer:</strong> DC Sports Report is an independent fan site and is not affiliated with, endorsed by, or connected to the Washington Commanders, Washington Nationals, Washington Capitals, Washington Wizards, Washington Mystics, DC United, Washington Spirit, DC Defenders, or any of their parent organizations. All team names and trademarks are property of their respective owners.
          </p>
          <p className="text-slate-400 text-sm mt-5">
            © {new Date().getFullYear()} DC Sports Report. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
